export default __webpack_public_path__ + "static/media/pass_img.431bce2c.png";